// ============================================================================
// BESPOKIAN Pharmacist Cockpit - PDMP Risk Factors
// Display component for PDMP risk factor analysis
// ============================================================================

import type { PDMPRiskFactor } from '@/types';
import { Badge } from '@/components/common/ui';

export interface RiskFactorsProps {
  factors: PDMPRiskFactor[];
}

export function RiskFactors({ factors }: RiskFactorsProps) {
  if (!factors || factors.length === 0) {
    return (
      <div className="rounded-lg bg-green-50 border border-green-200 p-4">
        <div className="text-green-800 font-semibold">
          ✓ No significant risk factors identified
        </div>
      </div>
    );
  }

  const severityColors = {
    HIGH: 'bg-red-50 border-red-200',
    MODERATE: 'bg-amber-50 border-amber-200',
    LOW: 'bg-blue-50 border-blue-200',
  };

  const severityBadge = {
    HIGH: 'danger' as const,
    MODERATE: 'warning' as const,
    LOW: 'info' as const,
  };

  return (
    <div className="space-y-3">
      {factors.map((factor, i) => (
        <div
          key={i}
          className={`rounded-lg border p-4 ${severityColors[factor.severity]}`}
        >
          <div className="flex items-center gap-2 mb-1">
            <Badge variant={severityBadge[factor.severity]}>
              {factor.severity}
            </Badge>
            <span className="font-semibold text-slate-900">{factor.type}</span>
          </div>
          <p className="text-sm text-slate-600">{factor.description}</p>
        </div>
      ))}
    </div>
  );
}
